// Customer-facing explanations for AI photo-ID validation results, shared by
// the signing wizard (IdVerification.vue) and the phone upload page
// (IdUpload.vue) so both surfaces explain a rejection the same way.
const ISSUE_MESSAGES = {
    blurry: 'The photo looks a bit blurry.',
    low_resolution: 'The photo is low resolution.',
    has_glare: 'There\'s glare or a reflection on the card.',
    too_dark: 'The photo is too dark.',
    too_bright: 'The photo is overexposed.',
    corner_cropped: 'One of the corners of the card is cut off.',
    edge_cropped: 'One of the edges of the card is cut off.',
    tilted: 'The card is tilted in the frame.',
    wrong_document_type: 'This doesn\'t look like a government-issued photo ID.',
    not_an_id: 'We couldn\'t recognize this as a photo ID.',
    expired: 'The ID appears to be expired.',
    photo_obscured: 'The portrait on the ID is obscured.',
    name_mismatch: 'The name on the ID doesn\'t match what we have on file.',
    dob_mismatch: 'The date of birth on the ID doesn\'t match what we have on file.',
    unreadable: 'Some of the text on the card is hard to read.',
    partial_obstruction: 'Part of the card is obstructed.',
    screenshot_of_id: 'This looks like a screenshot of an ID — please upload a real photo.'
};

/**
 * Turn a validation result into a deduped list of customer-facing messages.
 * Returns an empty array when there is nothing specific to say — callers
 * append their own context-appropriate fallback.
 */
export function describeValidationIssues(validation) {
    if (!validation) return [];
    const out = [];
    for (const slug of (validation.issues || [])) {
        if (ISSUE_MESSAGES[slug] && !out.includes(ISSUE_MESSAGES[slug])) out.push(ISSUE_MESSAGES[slug]);
    }
    // The model sometimes sets the booleans without the matching slug.
    if (validation.isId === false && !out.includes(ISSUE_MESSAGES.not_an_id)) out.push(ISSUE_MESSAGES.not_an_id);
    if (validation.nameMatch === false && !out.includes(ISSUE_MESSAGES.name_mismatch)) out.push(ISSUE_MESSAGES.name_mismatch);
    if (validation.dobMatch === false && !out.includes(ISSUE_MESSAGES.dob_mismatch)) out.push(ISSUE_MESSAGES.dob_mismatch);
    return out;
}
